import { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { ShoppingBag, RotateCw } from 'lucide-react';

// Update `buyLink` for each item once the Stripe checkout link is ready.
const MERCH_ITEMS = [
  {
    id: 'snow-washed-oversized-cincy-tee',
    name: 'Snow Washed Oversized Cincy',
    price: 37,
    front: 'https://static.prod-images.emergentagent.com/jobs/9544df15-faee-41c3-81e8-0b46cfeab455/images/fd181802847d73f308da36378e773256cc6fd5ecf230fa9f369180288c18f042.jpeg',
    back: 'https://static.prod-images.emergentagent.com/jobs/9544df15-faee-41c3-81e8-0b46cfeab455/images/e4e510be083643951a95c9ddd3e9804043e476521e9bca47b5fd6a806c00e638.jpeg',
    buyLink: null,
  },
  {
    id: 'snow-wash-drawstring-pants',
    name: 'Snow Wash Drawstring Pants',
    price: 44,
    front: 'https://static.prod-images.emergentagent.com/jobs/9544df15-faee-41c3-81e8-0b46cfeab455/images/6b6c2ac72d902411fedb112ec69eb646529fa70ea87dde4a55264b6295f49a65.jpeg',
    back: 'https://static.prod-images.emergentagent.com/jobs/9544df15-faee-41c3-81e8-0b46cfeab455/images/8a04d2ebc0d9d336eab115826dd9bd3fb8f09b0e5d426915812c8432accd6003.jpeg',
    buyLink: null,
  },
];

const MerchCard = ({ item }) => {
  const [showBack, setShowBack] = useState(false);

  return (
    <div
      className="bg-[#0d0d0d] border border-[#1a1a1a] hover:border-yellow-500/40 transition-colors rounded-sm overflow-hidden group"
      data-testid={`merch-card-${item.id}`}
    >
      <div className="relative aspect-square bg-black overflow-hidden flex items-center justify-center">
        <img
          src={showBack ? item.back : item.front}
          alt={item.name}
          className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <button
          onClick={() => setShowBack((v) => !v)}
          className="absolute bottom-3 right-3 flex items-center gap-1.5 bg-black/70 hover:bg-yellow-600 backdrop-blur-sm text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1.5 rounded-sm transition-colors"
          data-testid={`merch-toggle-view-${item.id}`}
        >
          <RotateCw size={11} />
          {showBack ? 'Front' : 'Back'}
        </button>
      </div>
      <div className="p-4 sm:p-5">
        <h3 className="text-white font-bold text-base sm:text-lg mb-1" data-testid={`merch-name-${item.id}`}>
          {item.name}
        </h3>
        <div className="flex items-center gap-2 mb-4">
          <span className="text-yellow-500 font-black text-xl" data-testid={`merch-price-${item.id}`}>
            ${item.price}
          </span>
          <span className="text-green-500 text-[10px] font-bold uppercase tracking-wider bg-green-500/10 px-2 py-0.5 rounded-sm">
            Free Shipping
          </span>
        </div>
        {item.buyLink ? (
          <a
            href={item.buyLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full py-2.5 bg-yellow-600 hover:bg-yellow-500 text-white font-bold text-sm uppercase tracking-wider transition-colors rounded-sm"
            data-testid={`merch-buy-${item.id}`}
          >
            <ShoppingBag size={16} />
            Buy Now
          </a>
        ) : (
          <button
            disabled
            className="flex items-center justify-center gap-2 w-full py-2.5 bg-[#1a1a1a] text-gray-500 font-bold text-sm uppercase tracking-wider rounded-sm cursor-not-allowed"
            data-testid={`merch-buy-${item.id}`}
          >
            Coming Soon
          </button>
        )}
      </div>
    </div>
  );
};

const MerchPage = () => {
  return (
    <div className="min-h-screen bg-black" data-testid="merch-page">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <div className="mb-8 text-center">
          <span className="block bg-yellow-600 text-white text-[10px] sm:text-xs font-bold uppercase tracking-widest px-3 py-1 w-fit mx-auto mb-4">
            Cincy Culture
          </span>
          <h1 className="text-3xl sm:text-5xl font-black text-white leading-tight mb-3" data-testid="merch-title">
            MERCH
          </h1>
          <p className="text-gray-400 text-sm sm:text-base max-w-lg mx-auto">
            Rep the 513. Every piece is free shipping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6" data-testid="merch-grid">
          {MERCH_ITEMS.map((item) => (
            <MerchCard key={item.id} item={item} />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MerchPage;
